import { ODSPriorityGroups } from "../../interfaces/Indicator";

const PriorityGroupChips = ({ groups }: { groups: ODSPriorityGroups[] }) => {
    if (!groups || groups.length === 0) return null;

    return (
        <div className="flex gap-2 items-center flex-wrap">
            <span className="text-gray-40 text-bmedium">Grupos prioritarios:</span>
            <div className="flex flex-wrap gap-2">
                {groups.map((g) => (
                    <span
                        className="px-2 py-1 text-error-40 rounded-sm bg-[#B0494F33] text-lmedium !font-normal"
                        key={g.id}
                    >
                        {g.nombre}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default PriorityGroupChips